import clickUtils from "./clickUtils";
import promotionPieces from "../standardChess/promotionPieces";

const fischerRandomChess = {
  clickUtils,
  promotionPieces
};

export default fischerRandomChess;